import { createPortal } from "react-dom";

import { Column, Text } from "@/components";
import { ChamferOutline } from "@/components/chamfer";

import { leverPerformanceTierTextClass } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { PerformanceTier } from "@/types";

const TOOLTIP_GAP_PX = 10;

// The hovered week's value, portalled out so the short card can't clip it.
export const TrendWeekTooltip = ({
  label,
  tier,
  value,
  x,
  y,
}: {
  label: string;
  tier: PerformanceTier | null;
  value: string;
  x: number;
  y: number;
}) =>
  createPortal(
    <Column
      className="lever-chart-tooltip pointer-events-none fixed z-50 whitespace-nowrap rounded-none border border-lever-border-light bg-lever-surface-default px-3 py-2 shadow-none"
      style={{
        left: x,
        top: y - TOOLTIP_GAP_PX,
        transform: "translate(-50%, -100%)",
      }}
    >
      <Column className="lever-chart-tooltip-surface">
        <ChamferOutline />
        <Text className="text-xs font-normal text-lever-text-label">
          Week of {label}
        </Text>
        <Text
          className={cn(
            "font-lever-accent text-lg font-normal tabular-nums leading-tight",
            tier
              ? leverPerformanceTierTextClass[tier]
              : "text-lever-text-label",
          )}
        >
          {value}
        </Text>
      </Column>
    </Column>,
    document.body,
  );
